export const CREATE_SCENARIO_PAGE_TITLE = "Create Scenario";

export const linkToCreateScenario = () => "/app/scenarios/create-scenario";
export const CREATE_SCENARIO_BREADCRUMB = {
  title: CREATE_SCENARIO_PAGE_TITLE,
  path: linkToCreateScenario,
};

export * from "./CreateScenarioPage";
